module.exports = __webpack_public_path__ + "static/media/Yummy.e4dd53e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work/Yummy.png
// module id = 54
// module chunks = 0